import React from "react";
import PaymentView from "../views/users/PaymentView";

const Payment: React.FC = () => {
    return <div><PaymentView /></div>;
};

export default Payment;